import script from "./showBill.vue?vue&type=script&setup=true&lang=ts"
export * from "./showBill.vue?vue&type=script&setup=true&lang=ts"

import "./showBill.vue?vue&type=style&index=0&id=14422047&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14422047"]])

export default __exports__